import { useGameStore } from '../stores/gameStore'

export default function AIContextMenu() {
  const { aiContextMenu, closeAIContextMenu, sendAICommand } = useGameStore()

  if (!aiContextMenu) return null

  const { type, screenX, screenY, worldX, worldY, markerId, markerType, markerDifficulty, aiId, aiList } = aiContextMenu

  // Adjust position to keep menu on screen
  const menuStyle: React.CSSProperties = {
    position: 'fixed',
    left: Math.min(screenX, window.innerWidth - 200),
    top: Math.min(screenY, window.innerHeight - 200),
    zIndex: 9999,
  }

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      closeAIContextMenu()
    }
  }

  // Menu for sending AI to a map location
  if (type === 'map') {
    return (
      <div
        className="fixed inset-0 z-50"
        onClick={handleBackdropClick}
        onContextMenu={(e) => e.preventDefault()}
      >
        <div
          style={menuStyle}
          className="bg-gray-900/95 border-2 border-emerald-500 rounded-lg p-2 min-w-[180px] shadow-xl"
        >
          <div className="text-gray-400 text-xs mb-2 text-center">Wyslij AI tutaj:</div>
          {aiList.map((ai) => (
            <button
              key={ai.id}
              onClick={() => sendAICommand('move', ai.id, { x: worldX, y: worldY })}
              className="w-full px-4 py-2 mb-1 bg-gray-800 hover:bg-gray-700 text-white rounded transition-colors text-left flex items-center gap-2"
            >
              <span
                className="w-4 h-4 rounded"
                style={{ backgroundColor: getRoleColor(ai.role) }}
              />
              <span>{ai.name}</span>
            </button>
          ))}
        </div>
      </div>
    )
  }

  // Menu for investigating a marker
  if (type === 'marker') {
    return (
      <div
        className="fixed inset-0 z-50"
        onClick={handleBackdropClick}
        onContextMenu={(e) => e.preventDefault()}
      >
        <div
          style={menuStyle}
          className="bg-gray-900/95 border-2 border-orange-500 rounded-lg p-2 min-w-[180px] shadow-xl"
        >
          <div className="text-gray-400 text-xs mb-2 text-center">Kaz AI zbadac:</div>
          {aiList.map((ai) => (
            <button
              key={ai.id}
              onClick={() => sendAICommand('investigate', ai.id, { markerId, x: worldX, y: worldY })}
              className="w-full px-4 py-2 mb-1 bg-gray-800 hover:bg-gray-700 text-white rounded transition-colors text-left flex items-center gap-2"
            >
              <span
                className="w-4 h-4 rounded"
                style={{ backgroundColor: getRoleColor(ai.role) }}
              />
              <span>{ai.name}</span>
            </button>
          ))}
        </div>
      </div>
    )
  }

  // Menu for AI return command
  if (type === 'ai' && aiId) {
    return (
      <div
        className="fixed inset-0 z-50"
        onClick={handleBackdropClick}
        onContextMenu={(e) => e.preventDefault()}
      >
        <div
          style={menuStyle}
          className="bg-gray-900/95 border-2 border-purple-500 rounded-lg p-2 min-w-[160px] shadow-xl"
        >
          <button
            onClick={() => sendAICommand('return', aiId)}
            className="w-full px-4 py-2 bg-gray-800 hover:bg-gray-700 text-white rounded transition-colors"
          >
            Wroc do mnie
          </button>
        </div>
      </div>
    )
  }

  return null
}

function getRoleColor(role: string): string {
  const colors: Record<string, string> = {
    flux: '#00FF66',
    logic: '#4488FF',
    spark: '#FF8844',
    echo: '#AA44FF',
  }
  return colors[role] || '#ffffff'
}
